import apiClientOC from 'icfrontendapiclient';
import API_CONFIG from './apiConfig';

export const configureApiClient = () => {
  const configStorage = apiClientOC.get("ConfigStorage");
  configStorage.set("bizapi_url_base", API_CONFIG.BASE_URL);
};

configureApiClient();

